import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { Button, ButtonProps, Flex, FlexProps } from '@mantine/core';
import { MouseEventHandler, type ComponentProps } from 'react';
import styled from 'styled-components';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainButton = asPlainComponent<ComponentProps<typeof Button>>(Button);

const ValuationsWarningsDropdownHeaderContainer = styled(Flex)<FlexProps>`
	border: 6px solid;
	border-color: #fff4f5; // no corresponding theme color
	border-radius: 100%;
	background-color: ${defaultTheme.v3.colors.red[0]};
	padding: 8px;
`;

export const ValuationsWarningsDropdownHeader = () => {
	return (
		<ValuationsWarningsDropdownHeaderContainer justify="center" align="center">
			<Icon
				style={{
					color: defaultTheme.v3.colors.red[6],
					marginTop: '-2px',
				}}
				variant="warning"
				size="xl"
			/>
		</ValuationsWarningsDropdownHeaderContainer>
	);
};

export const ValuationsWarningButton = styled(PlainButton)<
	ButtonProps & { onClick?: MouseEventHandler<HTMLButtonElement> }
>`
	&:hover {
		background-color: transparent;
	}

	.mantine-Text-root {
		padding: 0;
	}

	padding: 0;
`;

export const ValuationsWarningIconButton = styled(PlainButton)<
	ButtonProps & { onClick?: MouseEventHandler<HTMLButtonElement> }
>`
	border: 1px solid;
	border-color: ${({ theme }) => theme.v3.colors.red[0]};

	&[data-expanded='true'] {
		background-color: ${({ theme }) => theme.v3.colors.red[0]};
	}
`;
